import React from "react";

import type { JSX } from "react";

interface MenuButtonProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: React.ReactElement<any> | string;
}

export default function MenuButton({
  component,
  children,
}: React.PropsWithChildren<MenuButtonProps>): JSX.Element {
  if (component) {
    if (typeof component === "string") {
      return React.createElement(component, {}, children);
    }

    return React.cloneElement(
      component,
      {
        className: "group",
      },
      children,
    );
  }

  return <div>{children}</div>;
}
